import React from 'react'

function Copyrights() {
    return (
        <div className="container py-5">
            <div className="card shadow-sm border-0 rounded-3">
                <div className="card-body p-4 p-md-5">

                    <h5 className="fw-bold text-success border-bottom pb-3 mb-4">
                        Copyrights
                    </h5>

                    <p
                        className="text-secondary lh-lg mb-4"
                        style={{ textIndent: "2.5rem" }}
                    >
                        Material featured on this Portal may be reproduced free of charge after taking proper permission by sending a mail to us. However, the
                        material has to be reproduced accurately and not to be used in a derogatory manner or in misleading context. Wherever the material is being
                        published or issued to others the source must be prominently acknowledged. However, the permission to reproduce this material shall not
                        extend to any material which is identified as being copyright of a third party. Authorization to reproduce such material must be obtained from
                        the departments/copyright holders concerned. These terms and conditions shall be governed by and construed in accordance with the Indian
                        Laws. Any dispute arising under these terms and conditions shall be subject to the exclusive jurisdiction of the courts of India.
                    </p>

                </div>
            </div>
        </div>
    )
}

export default Copyrights